import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import {EntityAccountViewModel} from '../view-models/entity-account.view-model';

@Component({
    selector: 'app-entity-account-card',
    templateUrl: './entity-account-card.component.html',
    styleUrls: ['./entity-account-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EntityAccountCardComponent {
    public readonly entityAccount = input.required<EntityAccountViewModel>();
    public readonly cardClicked = output<EntityAccountViewModel>();

    handleClick(_event: Event): void {
        this.cardClicked.emit(this.entityAccount());
    }
}
